import script from "./SideMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SideMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SideMenu.vue?vue&type=style&index=0&id=fc3c0c88&lang=scss"

const __exports__ = script;

export default __exports__